<template>
  <div v-if="shouldShowModal" class="popup-wrap register-wrap" :class="{ active: shouldShowModal }">
    <div class="popup-box fullScreen-md">
      <a class="popup-close" @click="closeVerify"><i class="fa-solid fa-xmark" /></a>

      <div class="form-popup popup-padding persnal-data-frame">
        <div v-if="themeConfig.showPersonalAd" class="persnal-data-ad">
          <img :src="$getThemeImagePath('personal_data_ad.png')" alt="">
        </div>

        <form class="row-frame dep-form-frame reg-popupBox persnal-data-popupBox">
          <div class="reg-form-group">
            <div class="reg-form-area">
              <div class="register-sec-title">
                {{ $t("Bao.personal_info") }}
              </div>

              <div class="colu colu-auto">
                <label class="colu-sm-12 colu-md-4 colu-12 colu-form-label title-label" for="nationality">{{ $t('Bao.nationality') }}</label>

                <div class="colu-sm-12 colu-md-8 colu-12">
                  <select
                    id="nationality"
                    v-model="nationality"
                    v-validate="'required'"
                    class="colu-12 for-input"
                    :class="{ 'isInvalid': errors.has('nationality') }"
                    name="nationality"
                    :data-vv-as="$t('Bao.nationality')"
                    :disabled="!!memberInfo.nationality"
                  >
                    <option value="">
                      {{ $t('Bao.please_select') }}
                    </option>
                    <option
                      v-for="item in nationalityOptions"
                      :key="item.code"
                      :value="item.code"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                </div>
                <div v-if="errors.has('nationality')" class="input-feedback text-align-R">
                  {{ $t('Bao.nationality_error') }}
                </div>
              </div>

              <template v-if="!isTheme('theme_blue')">
                <div class="colu colu-auto">
                  <label class="colu-sm-12 colu-md-4 colu-12 colu-form-label title-label" for="姓（カタカナ）">{{ nameLabels.romLast }}</label>

                  <div class="colu-sm-12 colu-md-8 colu-12">
                    <input
                      id="姓（カタカナ）"
                      v-model="romanizationOfLastName"
                      v-validate="'required'"
                      class="colu-12 for-input inpType "
                      :class="{ 'isInvalid': errors.has('check_roman_last') || romanLastError }"
                      type="text"
                      name="check_roman_last"
                      :data-vv-as="$t('Bao.romanization_of_last_name')"
                      :required="true"
                      autocomplete="off"
                      :placeholder="namePlaceholders ? namePlaceholders.romLast : 'ヤマダ'"
                      @input="validateRomLastName"
                    >
                  </div>
                  <div v-if="errors.has('check_roman_last')" class="input-feedback text-align-R">
                    {{ $t("Bao.romanization_of_last_name_error") }}
                  </div>
                  <div v-else-if="romanLastError" class="input-feedback text-align-R">
                    {{ romanLastError }}
                  </div>
                </div>

                <div class="colu colu-auto">
                  <label class="colu-sm-12 colu-md-4 colu-12 colu-form-label title-label" for="名（カタカナ）">{{ nameLabels.romFirst }}</label>

                  <div class="colu-sm-12 colu-md-8 colu-12">
                    <input
                      id="名（カタカナ）"
                      v-model="romanizationOfFirstName"
                      v-validate="'required'"
                      class="colu-12 for-input inpType"
                      :class="{ 'isInvalid': errors.has('check_roman_first') || romanFirstError }"
                      type="text"
                      name="check_roman_first"
                      :data-vv-as="$t('Bao.romanization_of_first_name')"
                      :required="true"
                      autocomplete="off"
                      :placeholder="namePlaceholders ? namePlaceholders.romFirst : 'タロウ'"
                      @input="validateRomFirstName"
                    >
                  </div>
                  <div v-if="errors.has('check_roman_first')" class="input-feedback text-align-R">
                    {{ $t("Bao.romanization_of_first_name_error") }}
                  </div>
                  <div v-else-if="romanFirstError" class="input-feedback text-align-R">
                    {{ romanFirstError }}
                  </div>
                </div>
              </template>

              <div class="colu colu-auto">
                <label class="colu-sm-12 colu-md-4 colu-12 colu-form-label title-label" for="姓（漢字）">{{ nameLabels.nameLast }}</label>

                <div class="colu-sm-12 colu-md-8 colu-12">
                  <input
                    id="姓（漢字）"
                    v-model="lastName"
                    v-validate="'required'"
                    class="colu-12 for-input inpType"
                    :class="{ 'isInvalid': errors.has('check_last') }"
                    type="text"
                    name="check_last"
                    :data-vv-as="$t('Bao.last_name')"
                    :placeholder="namePlaceholders ? namePlaceholders.nameLast : (!isTheme('theme_blue') ? '山田' : $t('Bao.name_content_modal'))"
                    :required="true"
                    autocomplete="off"
                    @input="validateNameLast"
                  >
                </div>
                <div v-if="errors.has('check_last')" class="input-feedback text-align-R">
                  {{ $t("Bao.last_name_error") }}
                </div>
              </div>

              <div class="colu colu-auto">
                <label class="colu-sm-12 colu-md-4 colu-12 colu-form-label title-label" for="名（漢字）">{{ nameLabels.nameFirst }}</label>

                <div class="colu-sm-12 colu-md-8 colu-12">
                  <input
                    id="名（漢字）"
                    v-model="firstName"
                    v-validate="'required'"
                    class="colu-12 for-input inpType"
                    :class="{ 'isInvalid': errors.has('check_first') }"
                    type="text"
                    name="check_first"
                    :data-vv-as="$t('Bao.first_name')"
                    :required="true"
                    autocomplete="off"
                    :placeholder="namePlaceholders ? namePlaceholders.nameFirst : (!isTheme('theme_blue') ? '太郎' : $t('Bao.name_content_modal'))"
                    @input="validateNameFirst"
                  >
                </div>
                <div v-if="errors.has('check_first')" class="input-feedback text-align-R">
                  {{ $t("Bao.first_name_error") }}
                </div>
              </div>

              <div class="colu colu-auto">
                <label class="colu-sm-12 colu-md-4 colu-12 colu-form-label title-label" for="生年月日">{{ $t("Bao.birthday") }}</label>

                <div class="colu-sm-12 colu-md-8 colu-12">
                  <input
                    id="生年月日"
                    v-model="postForm.birthday"
                    v-validate="'required'"
                    class="colu-12 for-input inpType"
                    :class="{ 'isInvalid': errors.has('check_birth') }"
                    type="date"
                    name="check_birth"
                    :placeholder="$t('Bao.birthday')"
                    :max="maxDate"
                    autocomplete="off"
                  >
                </div>
                <div v-if="errors.has('check_birth')" class="input-feedback text-align-R">
                  {{ $t("Bao.birthday_error") }}
                </div>
              </div>

              <div class="colu colu-auto">
                <label class="colu-sm-12 colu-md-4 colu-12 colu-form-label title-label" for="住所">{{ $t("Bao.address") }}</label>

                <div class="colu-sm-12 colu-md-8 colu-12">
                  <input
                    id="住所"
                    v-model="postForm.address"
                    v-validate="'required'"
                    class="colu-12 for-input inpType"
                    :class="{ 'isInvalid': errors.has('_address') }"
                    name="_address"
                    :placeholder="$t('Bao.address')"
                    autocomplete="off"
                    type="text"
                  >
                </div>
                <div v-if="errors.has('_address')" class="input-feedback text-align-R">
                  <span>{{ $t("Bao.address_error") }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- reg-form-area End -->

          <div class="reg-form-area">
            <div
              v-if="memberInfo && (!memberInfo.email || !memberInfo.phone)"
              class="register-sec-title"
            >
              {{ $t("Bao.contact_info") }}
            </div>

            <div v-if="memberInfo && !memberInfo.email" class="colu colu-12">
              <label class="colu-sm-12 colu-md-4 colu-12 colu-form-label title-label" for="メールアドレス">{{ $t("Bao.e-mail") }}</label>

              <div class="colu-sm-12 colu-md-8 colu-12">
                <input
                  id="メールアドレス"
                  v-model="postForm.email"
                  v-validate="'required'"
                  class="colu-12 for-input inpType"
                  :class="{ 'isInvalid': errors.has('_email') }"
                  type="email"
                  name="_email"
                  :placeholder="$t('Bao.e-mail')"
                  autocomplete="off"
                >
              </div>
              <div v-if="errors.has('_email')" class="input-feedback text-align-R">
                <span>{{ $t("Bao.email_error") }}</span>
              </div>
            </div>

            <div v-if="memberInfo && !memberInfo.phone" class="colu colu-auto">
              <label class="colu-sm-12 colu-md-4 colu-12 colu-form-label title-label" for="携帯番号">{{ $t("Bao.phone") }}</label>

              <div class="colu-sm-12 colu-md-8 colu-12 country-select-frame">
                <div class="row-frame ml-0">
                  <div class="colu-3 country-select-box" :class="{ active: isActive }" @click="toggleActive">
                    <div class="form-select-1 country-select">
                      <div class="form-select-value">
                        <div class="country-flag" />
                        <div class="country-code">
                          {{ selectedCode }}
                        </div>

                        <div class="country-list-box slideUp">
                          <ul class="country-list">
                            <li
                              v-for="(code, key) in brand.supportPhoneCode"
                              :key="key"
                              @click.stop="selectCode(code)"
                            >
                              <div class="country-flag" />
                              <div class="country-code">
                                {{ code }}
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <i class="fa-solid fa-angle-right " aria-hidden="true" />
                  </div>
                  <div class="colu-9 number-box">
                    <input
                      id="携帯番号"
                      v-model="postForm.phone"
                      v-validate="'required'"
                      class="colu-12 for-input inpType"
                      :class="{ 'isInvalid': phoneError && phoneError !== $t('Bao.phone_available') }"
                      type="text"
                      name="personal_phone"
                      :data-vv-as="$t('Bao.phone')"
                      :required="true"
                      autocomplete="off"
                      @input="phonecheck"
                    >
                  </div>
                </div>
              </div>
              <div v-if="phoneError === $t('Bao.phone_available')" class="account_good">
                {{ phoneError }}
              </div>
              <div v-else-if="phoneError" class="input-feedback text-align-R">
                {{ phoneError }}
              </div>
            </div>

            <div class="form-button form-ft">
              <button
                class="btn-primary"
                :disabled="isButtonDisabled"
                @click.prevent="save"
              >
                <span>個人情報の入力</span>
              </button>
            </div>
          </div>
        </form>
      </div>

      <i class="content-left dis_none" />
    </div>
  </div>
</template>

<script>
import { update, phoneCheck } from '@/api/user'
import { showNotice } from '@/utils/tool'
import { getNationalityOptions, sanitizeNameField, getNameFieldLabels, getNameFieldPlaceholders } from '@/utils/nationality'
import { mapGetters } from 'vuex'
import themeMixin from '@/mixins/themeMixin'

export default {
  name: 'PersonalDataModal',
  mixins: [themeMixin],
  data() {
    const postForm = {
      romanization: null, // 羅馬拼音
      name: null, // 漢字拼音
      email: null,
      birthday: null,
      phone: null,
      address: null
    }
    return {
      actionLoading: false,
      postForm,
      romanizationOfLastName: '',
      romanizationOfFirstName: '',
      romanLastError: '',
      romanFirstError: '',
      lastName: '',
      firstName: '',
      isPhoneValid: false,
      phoneError: '',
      isActive: false,
      selectedCode: '',
      nationality: ''
    }
  },
  computed: {
    ...mapGetters(['memberInfo', 'token', 'brand']),
    nationalityOptions() {
      return getNationalityOptions(this.brand.supportNationality)
    },
    nameLabels() {
      const override = getNameFieldLabels(this.nationality)
      return {
        nameLast: override ? override.nameLast : this.$t('Bao.last_name'),
        nameFirst: override ? override.nameFirst : this.$t('Bao.first_name'),
        romLast: override ? override.romLast : this.$t('Bao.romanization_of_last_name'),
        romFirst: override ? override.romFirst : this.$t('Bao.romanization_of_first_name')
      }
    },
    namePlaceholders() {
      return getNameFieldPlaceholders(this.nationality)
    },
    combinedRomanization() {
      return this.romanizationOfLastName && this.romanizationOfFirstName
        ? this.romanizationOfLastName + ',' + this.romanizationOfFirstName
        : null
    },
    combinedName() {
      return this.lastName && this.firstName
        ? this.lastName + ',' + this.firstName
        : null
    },
    isButtonDisabled() {
      const hasErrors = this.errors.any()
      /* eslint-disable no-unused-vars */
      let formToCheck
      if (this.memberInfo.phone && this.memberInfo.email) {
        const { phone, email, ...rest } = this.postForm
        formToCheck = rest
      } else if (this.memberInfo.phone) {
        const { phone, ...rest } = this.postForm
        formToCheck = rest
      } else if (this.memberInfo.email) {
        const { email, ...rest } = this.postForm
        formToCheck = rest
      }

      if (this.isTheme('theme_blue')) {
        const { romanization, ...rest } = formToCheck
        formToCheck = rest
      }

      const hasEmptyFields = Object.values(formToCheck).some(value => value === null || value === '')

      return hasErrors ||
        !this.nationality ||
        (!this.isTheme('theme_blue') && this.romanFirstError) ||
        (!this.isTheme('theme_blue') && this.romanLastError) ||
        (!this.memberInfo.phone && !this.isPhoneValid) ||
        hasEmptyFields
    },
    isUserDataComplete() {
      // 檢查me裡面的欄位是否有資料 romanization(theme_blue不檢查),name,address,birthday,phone,email
      if (!this.memberInfo) return false

      const requiredFields = this.isTheme('theme_blue')
        ? ['name', 'address', 'birthday']
        : ['romanization', 'name', 'address', 'birthday']

      const hasAllRequired = requiredFields.every(field => {
        const value = this.memberInfo[field]
        return value && value.toString().trim() !== ''
      })

      const hasContact = (this.memberInfo.phone && this.memberInfo.phone.trim() !== '') ||
                        (this.memberInfo.email && this.memberInfo.email.trim() !== '')

      return hasAllRequired && hasContact
    },
    shouldShowModal() {
      if (!this.token) return false
      if (this.isUserDataComplete) return false
      if (this.$route.path === '/personal/data/modal') return true
      return false
    },
    maxDate() {
      const currentDate = new Date()
      const year = currentDate.getFullYear().toString()
      const month = (currentDate.getMonth() + 1).toString().padStart(2, '0')
      const day = currentDate.getDate().toString().padStart(2, '0')
      const maxDate = `${year}-${month}-${day}`
      return maxDate
    }
  },
  watch: {
    combinedRomanization(newValue) {
      this.postForm.romanization = newValue
    },
    combinedName(newValue) {
      this.postForm.name = newValue
    },
    nationality() {
      this.sanitizeAllNameFields()
    },
    token(newVal) {
      if (!newVal) {
        this.goHome()
      } else {
        this.checkModalDisplay()
      }
    },

    isUserDataComplete(newVal) {
      if (newVal) {
        this.goHome()
      }
    },
    '$route'() {
      this.checkModalDisplay()
    },
    'brand.supportPhoneCode': {
      handler(newVal) {
        if (newVal && newVal.length > 0 && !this.selectedCode) {
          this.selectedCode = newVal[0]
        }
      },
      immediate: true
    }
  },
  created() {
    this.nationality = this.memberInfo.nationality || ''
    if (!this.memberInfo.phone) {
      this.debounceCheckPhone = this.debounce(this.phoneApiCall, 500)
    }
  },
  mounted() {
    if (!this.token) {
      this.goHome()
      return
    }
    this.checkModalDisplay()
  },
  methods: {
    checkModalDisplay() {
      if (!this.token || this.isUserDataComplete) {
        this.goHome()
        return
      }

      const shouldShow = this.$route.path === '/personal/data/modal'
      if (!shouldShow) {
        this.goHome()
        return
      }
    },
    goHome() {
      this.$router.push('/')
    },
    closeVerify() {
      this.goHome()
    },
    validateRomLastName(e) {
      if (e && e.isComposing) return
      this.romanizationOfLastName = sanitizeNameField(this.romanizationOfLastName, this.nationality, 'romanization')
    },
    validateRomFirstName(e) {
      if (e && e.isComposing) return
      this.romanizationOfFirstName = sanitizeNameField(this.romanizationOfFirstName, this.nationality, 'romanization')
    },
    validateNameLast(e) {
      if (e && e.isComposing) return
      this.lastName = sanitizeNameField(this.lastName, this.nationality, 'name')
    },
    validateNameFirst(e) {
      if (e && e.isComposing) return
      this.firstName = sanitizeNameField(this.firstName, this.nationality, 'name')
    },
    sanitizeAllNameFields() {
      this.validateRomLastName()
      this.validateRomFirstName()
      this.validateNameLast()
      this.validateNameFirst()
    },
    deactivatePopup() {
      this.$store.commit('SET_REGISTER_OPEN', false)
      this.errors.clear()
      this.agree_error = false
    },
    save() {
      this.actionLoading = true

      const phone = this.postForm.phone
      if (this.memberInfo.phone) {
        this.postForm.phone = null
      } else {
        this.postForm.phone = this.selectedCode + phone
      }

      if (this.memberInfo.email) {
        this.postForm.email = null
      }

      update({ ...this.postForm, nationality: this.nationality }).then(response => {
        this.$store.commit('SET_MEMBER_INFO', response.data.data.member_info)
        showNotice(this.$t('Bao.update_success'))
      }).catch((error) => {
        this.postForm.phone = phone
        showNotice(error.response.data.msg)
      }).finally((e) => {
        this.actionLoading = false
      })
    },
    phoneApiCall() {
      if (this.postForm.phone && this.postForm.phone.trim() !== '') {
        phoneCheck({ phone: this.selectedCode + this.postForm.phone }).then(res => {
          this.phoneError = this.$t('Bao.phone_available')
          this.isPhoneValid = true
        }).catch(err => {
          console.log(err)
          this.phoneError = this.$t('Bao.phone_error')
          this.isPhoneValid = false
        })
      }
    },
    phonecheck() {
      if (!this.postForm.phone) {
        this.phoneError = this.$t('Bao.phone_error')
        this.isPhoneValid = false
      } else {
        this.debounceCheckPhone()
      }
    },
    debounce: function(func, wait) {
      let timeout
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout)
          func(...args)
        }
        clearTimeout(timeout)
        timeout = setTimeout(later, wait)
      }
    },
    toggleActive() {
      this.isActive = !this.isActive
    },
    selectCode(code) {
      this.isActive = false
      this.selectedCode = code
    }
  }
}
</script>
